module.exports = __webpack_public_path__ + "img/Sprouts_Logo_4C11.a48c2c3f.png";